import { useContext } from "react";

import { ParamsContext } from "./ParamsContext";

export function useCustomParams() {
  const context = useContext(ParamsContext);
  if (!context) {
    throw new Error("useCustomParams must be used within a ParamsProvider");
  }

  return context;
}
